<template>
  <div v-loading="loading" class="month-metrix">
    <div class="header">
      <div class="pre">
        <el-button type="text" @click="goPreMonth">上一季</el-button>
      </div>
      <div class="title">
        <season-selector v-model="curSeasonForSelector" style="float: none;" @change="fastSelect"></season-selector>
        <span style="user-select: none; margin-left: 8px; color:#409EFF; cursor: pointer;" @click="$emit('spanChange', 'month')">季度</span>
        <span>销售任务</span>
        <span style="font-weight: normal; font-size: 14px; margin-left: 8px; color: #9d9d9d;">{{ percentNow | processTipFmt }}</span>
        <el-button type="text" @click="exportExcel">下载</el-button>
      </div>
      <div v-if="!isEnd" class="next">
        <el-button type="text" @click="goNextMonth">下一季</el-button>
      </div>
    </div>
    <div v-if="tableData.length" class="context">
      <el-table :data="tableData" @sort-change="doSort">
        <el-table-column prop="area" property="area" label="区域" fixed sortable="custom" min-width="120"></el-table-column>
        <el-table-column v-for="(m, idx) in metrixs" :label="m.metrixName" :property="`${m.metrix}Result`" :key="idx + m.metrix" sortable="custom">
          <el-table-column :prop="`${m.metrix}Target`" :label="`${showSeasonStr}目标`" min-width="120">
            <template slot-scope="scope">
              <div class="cell">
                <span v-if="m.metrix.endsWith('Count')">{{ scope.row[`${m.metrix}Target`] }}</span>
                <span v-else>{{ scope.row[`${m.metrix}Target`] | wanFmt }}</span>
                <el-button type="text" @click="configMonthTask" v-uac="'dashboard.settask'"><i class="el-icon-edit" /></el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :prop="`${m.metrix}Result`" label="达成" min-width="120">
            <template slot-scope="scope">
              <div class="cell" :class="{ danger: scope.row[`${m.metrix}Target`] && (scope.row[`${m.metrix}Result`] / scope.row[`${m.metrix}Target`]) < percentNow, health: scope.row[`${m.metrix}Target`] && (scope.row[`${m.metrix}Result`] / scope.row[`${m.metrix}Target`]) >= percentNow }">
                <div v-if="m.metrix.endsWith('Count')">{{ scope.row[`${m.metrix}Result`] }}<span v-if="m.metrix === 'epcAmountCount'">元</span></div>
                <div v-else>{{ scope.row[`${m.metrix}Result`] | wanFmt }}</div>
                <div v-if="scope.row[`${m.metrix}Target`]" class="percent">
                  ({{ (scope.row[`${m.metrix}Result`] / scope.row[`${m.metrix}Target`]) | percentFmt }})
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :prop="`${m.metrix}LastMonthResult`" label="上季度" min-width="120">
            <template slot-scope="scope">
              <div class="cell">
                <div v-if="m.metrix.endsWith('Count')">{{ scope.row[`${m.metrix}LastMonthResult`] }}<span v-if="m.metrix === 'epcAmountCount'">元</span></div>
                <div v-else>{{ scope.row[`${m.metrix}LastMonthResult`] | wanFmt }}</div>
                <div v-if="scope.row[`${m.metrix}LastMonthTarget`]" class="percent">
                  ({{ (scope.row[`${m.metrix}LastMonthResult`] / scope.row[`${m.metrix}LastMonthTarget`]) | percentFmt }})
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :prop="`${m.metrix}LastYearResult`" label="去年同期" min-width="120">
            <template slot-scope="scope">
              <div class="cell">
                <div v-if="m.metrix.endsWith('Count')">{{ scope.row[`${m.metrix}LastYearResult`] }}<span v-if="m.metrix === 'epcAmountCount'">元</span></div>
                <div v-else>{{ scope.row[`${m.metrix}LastYearResult`] | wanFmt }}</div>
                <div v-if="scope.row[`${m.metrix}LastYearTarget`]" class="percent">
                  ({{ (scope.row[`${m.metrix}LastYearResult`] / scope.row[`${m.metrix}LastYearTarget`]) | percentFmt }})
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div v-else class="no-data">
      暂未设置销售任务,<el-button type="text" v-uac="'dashboard.settask'" @click="configMonthTask">去设置</el-button>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { listSeasonMetrix } from '../services'
import SeasonSelector from '@/components/SeasonSelector.vue'
import { Exporter as ExcelExporter } from '@/libs/excelfile'
import _ from 'lodash'
export default {
  name: 'MonthTask',
  components: { SeasonSelector },
  filters: {
    processTipFmt (val) {
      if (val === 0) {
        return '--'
      } else if (val === 1) {
        return '本季度已完结'
      } else {
        return `${moment().format('YYYY-MM-DD')}(${(val * 100).toFixed(2) + '%'})`
      }
    },
    percentFmt (val) {
      return (val * 100).toFixed(2) + '%'
    },
    wanFmt (val) {
      if (val) {
        let numberStr = (+val / 10000).toFixed(2)
        if (numberStr.endsWith('.00')) {
          numberStr = numberStr.substring(0, numberStr.length - 3)
        }
        return numberStr + '万'
      } else {
        return val
      }
    }
  },
  data () {
    const quaterStr = moment().format('YYYY-[Q]Q')
    const quaterStart = moment().startOf('quarter').toDate().getTime()
    return {
      curSeason: quaterStr,
      curSeasonForSelector: quaterStart,
      loading: false,
      monthData: [],
      tableData: [],
      metrixs: []
    }
  },
  computed: {
    quarterNow () {
      return moment().format('YYYY-[Q]Q')
    },
    isEnd () {
      const nextQuarter = moment().add(3, 'months')
      return this.curSeason === nextQuarter.format('YYYY-[Q]Q')
    },
    showSeasonStr () {
      return 'Q' + moment(this.curSeasonForSelector || undefined).quarter()
    },
    percentNow () {
      if (this.curSeason === this.quarterNow) {
        const duration = moment(this.curSeasonForSelector).add(3, 'months').diff(moment(this.curSeasonForSelector), 'days')
        const nowDays = moment().diff(moment(this.curSeasonForSelector), 'days')
        return nowDays / duration
      } else if (this.isEnd) {
        return 0
      } else {
        return 1
      }
    }
  },
  watch: {
    area () {
      this.loadSeasonTasks(this.curSeason)
    }
  },
  created () {
    this.setShowSeason(this.curSeasonForSelector)
  },
  methods: {
    doSort (col) {
      if (col.order === null) {
        this.convertTableData()
        return
      }
      const sortedData = this.tableData.slice(0, this.tableData.length - 1)
      sortedData.sort((a, b) => {
        if (col.prop === 'area') {
          if (col.order === 'ascending') {
            return a.area.localeCompare(b.area)
          } else if (col.order === 'descending') {
            return b.area.localeCompare(a.area)
          }
        }
        if (col.order === 'ascending') {
          return a[col.prop] - b[col.prop]
        } else if (col.order === 'descending') {
          return b[col.prop] - a[col.prop]
        }
      })
      this.tableData.splice(0, this.tableData.length - 1, ...sortedData)
    },
    fastSelect (newVal) {
      this.setShowSeason(newVal)
    },
    goPreMonth () {
      const preQuarter = moment(this.curSeasonForSelector).add(-3, 'months').toDate().getTime()
      this.setShowSeason(preQuarter)
    },
    goNextMonth () {
      const nextQuarter = moment(this.curSeasonForSelector).add(3, 'months').toDate().getTime()
      this.setShowSeason(nextQuarter)
    },
    setShowSeason (startQuarterTime) {
      this.curSeason = moment(startQuarterTime).format('YYYY-[Q]Q')
      this.curSeasonForSelector = startQuarterTime
      this.loadSeasonTasks(this.curSeason)
      this.$emit('changeSeason', startQuarterTime)
    },
    loadSeasonTasks (month) {
      this.loading = true
      listSeasonMetrix(month, this.area).then(monthData => {
        this.monthData = monthData
        this.convertTableData()
      }).finally(() => {
        this.loading = false
      })
    },
    configMonthTask () {
      // 配置某月数据
      this.modal('SetSeasonMetrixModal', this.monthData, this.curSeason).promise.then((resp) => {
        if (resp) {
          this.loadSeasonTasks(this.curSeason)
        }
      })
    },
    convertTableData () {
      const grp = _.groupBy(this.monthData, t => t.area)
      const areas = []
      for (let area in grp) {
        areas.push(area)
      }
      areas.sort((a, b) => a.localeCompare(b))
      const metrixs = []
      Array.from(new Set(this.monthData.map(t => t.metrix))).forEach(m => {
        const areaMetrix = this.monthData.find(t => t.metrix === m)
        metrixs.push({
          metrix: m,
          metrixName: areaMetrix.metrixName
        })
      })
      const tableData = []
      for (var area of areas) {
        const rowData = {
          area
        }
        metrixs.forEach(m => {
          var areaMetrixSpec = grp[area].find(t => t.metrix === m.metrix)
          rowData[m.metrix + 'Target'] = areaMetrixSpec.metrixTarget
          rowData[m.metrix + 'Result'] = areaMetrixSpec.metrixResult
          rowData[m.metrix + 'LastMonthResult'] = areaMetrixSpec.lastMonthResult
          rowData[m.metrix + 'LastYearResult'] = areaMetrixSpec.lastYearResult
        })
        tableData.push(rowData)
      }
      if (tableData.length > 1) {
        const totalRow = {
          area: '合计'
        }
        metrixs.forEach(m => {
          var metrixSpecs = this.monthData.filter(t => t.metrix === m.metrix)
          totalRow[m.metrix + 'Target'] = +(metrixSpecs.reduce((p, c) => p + c.metrixTarget, 0).toFixed(2))
          totalRow[m.metrix + 'Result'] = +(metrixSpecs.reduce((p, c) => p + c.metrixResult, 0).toFixed(2))
          totalRow[m.metrix + 'LastMonthResult'] = +(metrixSpecs.reduce((p, c) => p + c.lastMonthResult, 0).toFixed(2))
          totalRow[m.metrix + 'LastYearResult'] = +(metrixSpecs.reduce((p, c) => p + c.lastYearResult, 0).toFixed(2))
        })
        tableData.push(totalRow)
      }
      this.tableData.splice(0, this.tableData.length)
      this.metrixs.splice(0, this.metrixs.length)
      this.tableData.push(...tableData)
      this.metrixs.push(...metrixs)
    },
    exportExcel () {
      const mergeInfo = [
        {
          s: { r: 0, c: 0 },
          e: { r: 1, c: 0 }
        }
      ]
      const options = {
        '!cols': [
          { wpx: 80 }
        ],
        headerRows: 2
      }
      const exportData = []
      const headerRow1 = ['区域']
      const headerRow2 = [null]
      exportData.push(headerRow1, headerRow2)
      this.metrixs.forEach((metrix, index) => {
        headerRow1.push(metrix.metrixName, null, null, null, null)
        headerRow2.push(`${this.showSeasonStr}目标`, '达成率', '达成', '上季度', '去年同期')
        mergeInfo.push({
          s: { r: 0, c: index * 5 + 1 },
          e: { r: 0, c: (index + 1) * 5 }
        })
        options['!cols'].push({ wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 })
      })
      this.tableData.forEach(row => {
        const dataRow = [row.area]
        this.metrixs.forEach((metrix) => {
          dataRow.push(row[`${metrix.metrix}Target`])
          if (row[`${metrix.metrix}Target`] > 0) {
            const percent = (row[`${metrix.metrix}Result`] / row[`${metrix.metrix}Target`] * 100).toFixed(2) + '%'
            dataRow.push(percent)
          } else {
            dataRow.push('--')
          }
          dataRow.push(row[`${metrix.metrix}Result`])
          dataRow.push(row[`${metrix.metrix}LastMonthResult`])
          dataRow.push(row[`${metrix.metrix}LastYearResult`])
        })
        exportData.push(dataRow)
      })
      return ExcelExporter(
        exportData,
        mergeInfo,
        `${this.showSeasonStr}销售任务导出.xlsx`,
        '销售统计',
        options
      ).catch(() => {
        this.$message.error('导出失败')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
